<div class="bg-secondary">
  <main>
    <div class="container">
      <legend>Users</legend>
      <div class="row1">
        <div>
          <b-form inline>
            <label class="sr-only" for="inline-form-input-name">Voucher</label>
            <b-form-input v-model="voucher" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="voucher"></b-form-input>
            <b-button @click="onSearch()" variant="primary">Search</b-button>
          </b-form>
        </div>
        <br />
        <br />
      </div>
      <!--Grid row-->
      <div class="row1">
        <b-card>
          <b-form-group label="Currency" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.currency" disabled></b-form-input>
          </b-form-group>

          <b-form-group label="Amount" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.amount" disabled></b-form-input>
          </b-form-group>
          <b-form-group label="Generated On" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.createdOn" disabled></b-form-input>
          </b-form-group>

          <b-form-group label="Redeemed" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.redeemed" disabled></b-form-input>
          </b-form-group>
          <b-form-group label="Redeemed By" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.redeemedBy" disabled></b-form-input>
          </b-form-group>
          <b-form-group label="Reference" label-for="input-1">
            <b-form-input id="input-1" v-model="tauraResponse.reference" disabled></b-form-input>

            <b-form-group label="Redeemed on" label-for="input-1">
              <b-form-input id="input-1" v-model="tauraResponse.updatedOn" disabled></b-form-input>
            </b-form-group>
            <b-form-group label="Re-Instated On" label-for="input-1">
              <b-form-input id="input-1" v-model="tauraResponse.reInstatedOn" disabled></b-form-input>
            </b-form-group>

            <b-form-group>
              <base-button class="btn-3" @click="busy=true" type="primary">Re-Instate</base-button>
            </b-form-group>
        </b-card>
      </div>
      <!--Grid row-->
      <b-overlay :show="busy" no-wrap>
        <template #overlay>
          <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
            <b-icon icon="cloud" font-scale="4"></b-icon>
            <div class="mb-3">Processing...</div>
            <div class="text-center">
              <b-spinner type="grow" label="Spinning"></b-spinner>
            </div>
          </div>
          <div v-else ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label"
            class="text-center p-3">
            <p><strong id="form-confirm-label">Are you sure, you want to instate this voucher?</strong></p>
            <div class="d-flex">
              <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                Cancel
              </b-button>
              <b-button variant="outline-success" @click="onOK">OK</b-button>
            </div>
          </div>
        </template>
      </b-overlay>
    </div>
  </main>
  <!--Main layout-->
</div>